import React from 'react'
import { Box, Typography } from '@material-ui/core'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'
import LoadingSpinner from 'components/loading-spinner'

// Demo data for the monthly chart if no data is available
const DEMO_MONTHLY_DATA = [
  { month: '2023-05', count: 8 },
  { month: '2023-06', count: 10 },
  { month: '2023-07', count: 12 },
  { month: '2023-08', count: 15 },
  { month: '2023-09', count: 9 },
  { month: '2023-10', count: 14 },
  { month: '2023-11', count: 16 },
  { month: '2023-12', count: 18 },
  { month: '2024-01', count: 17 },
  { month: '2024-02', count: 19 },
  { month: '2024-03', count: 22 },
]

const GroupEventMonthlyChart = ({
  data,
  title = 'Group Event Enrollments By Month',
  className,
  loading,
  error,
}) => {
  const renderContent = () => {
    if (loading) return <LoadingSpinner />
    if (error) return <Box p={3}>Error loading chart data</Box>

    // Use demo data if no data is available
    const chartData = data && data.length > 0 ? data : DEMO_MONTHLY_DATA

    return (
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={chartData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12 }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12 }}
            tickFormatter={value => `${value}`}
          />
          <Tooltip formatter={value => [`${value}`, 'Enrollments']} />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#2053FF"
            strokeWidth={2}
            dot={{ fill: '#2053FF', r: 4 }}
            activeDot={{ r: 6 }}
            name="Enrollments"
            animationDuration={1800}
            animationBegin={300}
          />
        </LineChart>
      </ResponsiveContainer>
    )
  }

  return (
    <Box className={className}>
      <Typography variant="h6" style={{ marginBottom: '16px' }}>
        {title}
      </Typography>
      <Box style={{ height: 420 }}>{renderContent()}</Box>
    </Box>
  )
}

export default GroupEventMonthlyChart
